import { FC } from "react";
import { DRAFT_TEAM_STATUS, HIDDEN_TEAM_STATUS, REJECTED_TEAM_STATUS, UNDER_APPROVAL_TEAM_STATUS } from "shared/helpers/teamsStatus";
import { DraftBadge, HiddenBadge, ModerationBadge, RejectedBadge, SubscriptionsBadge } from "./styles";
import { useTranslation } from "react-i18next";

const TEAM_WITHOUT_UPDATE_SING = '01.01.1';

export const SubscriptionsTeamBadge: FC<{ date?: string }> = ({ date }) => {
    const { t , i18n: { language }} = useTranslation();

    const formatDate = (dateString: string | null | undefined): string => {
        if (!dateString) return '';
      
        const date = new Date(dateString);
      
        if (isNaN(date.getTime())) return '';
      
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();

        if (`${day}.${month}.${year}` === TEAM_WITHOUT_UPDATE_SING) {
            return ''
        }

        if (language === 'ru') {
            return `Обновлено ${day}.${month}.${year}`
        }
      
        return `Update ${day}.${month}.${year}`
      };

      const normalizeData = formatDate(date);

    if (normalizeData === '') return null;


    return <SubscriptionsBadge>{formatDate(date)}</SubscriptionsBadge>
}import { FC } from "react";
import { DRAFT_TEAM_STATUS, HIDDEN_TEAM_STATUS, REJECTED_TEAM_STATUS, UNDER_APPROVAL_TEAM_STATUS } from "shared/helpers/teamsStatus";
import { DraftBadge, HiddenBadge, ModerationBadge, RejectedBadge, SubscriptionsBadge } from "./styles";
import { useTranslation } from "react-i18next";

const TEAM_WITHOUT_UPDATE_SING = '01.01.1';

export const SubscriptionsTeamBadge: FC<{ date?: string }> = ({ date }) => {
    const { t , i18n: { language }} = useTranslation();

    const formatDate = (dateString: string | null | undefined): string => {
        if (!dateString) return '';
      
        const date = new Date(dateString);
      
        if (isNaN(date.getTime())) return '';
      
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();

        if (`${day}.${month}.${year}` === TEAM_WITHOUT_UPDATE_SING) {
            return ''
        }

        if (language === 'ru') {
            return `Обновлено ${day}.${month}.${year}`
        }
      
        return `Update ${day}.${month}.${year}`
      };

      const normalizeData = formatDate(date);

    if (normalizeData === '') return null;


    return <SubscriptionsBadge>{formatDate(date)}</SubscriptionsBadge>
}